module.exports = __webpack_public_path__ + "img/etape3.784cdd16.png";